import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/InvOrders/ReportLoad',
    method: 'post',
    data
  });
}

export function getloadfile(data) {
  return request({
    url: '/InvOrders/GetReportLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}

// 更新库存状态
export function AsyncStoreState() {
  return request({
    url: '/InvOrderDetails/AsyncStoreState',
    method: 'get'
  });
}

// 更新整体状态
export function AllAsyncStoreState() {
  return request({
    url: '/InvOrderDetails/AllAsyncStoreState',
    method: 'get'
  });
}
